<template>
  <van-tabbar v-model="type" @change="onChange" active-color="#866638" inactive-color="#666" style="border-top: 1px solid #ebebeb; box-sizing: border-box; background-color: #fff; z-index: 200">
    <van-tabbar-item>
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tab/11.avif' : '/static/image/tab/1.avif'" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>优惠</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tab/22.avif' : '/static/image/tab/2.avif'" />

      </template>
    </van-tabbar-item>
    <van-tabbar-item v-if="$store.state.token">
      <div class="ui-badge ui-badge--top-right ui-badge--fixed" style="color: rgb(255, 255, 0); z-index: 0; --badge-bg-color: var(--skin__accent_2);"><!----><div class="ui-badge__content">送2%</div></div>
      <span>充值</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tab/33.png' : '/static/image/tab/icon_btm_cz.avif'" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item v-if="$store.state.token">
      <span>提现</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tab/44.png' : '/static/image/tab/icon_btm_tx.avif'" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item v-if="!$store.state.token">
      <span>注册</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tab/icon_btm_zc.avif' : '/static/image/tab/icon_btm_zc.avif'" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item v-if="!$store.state.token">
      <span>APP下载</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tab/icon_btm_app.avif' : '/static/image/tab/icon_btm_app.avif'" />
      </template>
    </van-tabbar-item>
    <!-- <van-tabbar-item>
      <span>客服</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tab/33.png' : '/static/image/tab/3.png'" />

      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>赞助</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tab/44.png' : '/static/image/tab/4.avif'" />
      </template>
    </van-tabbar-item> -->
    <van-tabbar-item>
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tab/55.avif' : '/static/image/tab/5.avif'" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
//
export default {
  name: 'Foot',
  data() {
    return { type: 0 };
  },
  methods: {
    onChange(type) {
      let that = this;
      if (type == 0) {
        that.$parent.goNav(`/`);
      }
      if (type == 1) {
        that.$parent.goNav(`/activity`);
      }
      if (type == 2) {
        // that.$parent.openKefu();
        if(that.$store.state.token){
          that.$parent.goNav(`/recharge`);
        }else{
          that.$router.push('/login?type=1');
        }
      }
      if (type == 3) {
        if(that.$store.state.token){
          that.$parent.goNav(`/withdrawal`);
        }else{
          that.$parent.goNav(`/app`);
        }
        
      }
      if (type == 4) {
        that.$parent.goNav(`/mine`);
      }
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      if (path == '/') {
        that.type = 0;
      }
      if (path == '/activity') {
        that.type = 1;
      }

      if (path == '/kefu') {
        that.type = 2;
      }
      if (path == '/zhanzhu') {
        that.type = 3;
      }
      if (path == '/mine') {
        that.type = 4;
      }
      if (path == '/gamePage' || path == '/hongbao') {
        that.type = 5;
      }
    },
  },
  mounted() {},
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
.van-tabbar-item__icon img {
  display: block;
  height: 24px;
}
.van-tabbar-item {
  font-size: 14px;
  
}
.van-tabbar {
  height: 68px;
}
.van-tabbar-item--active {
  // background-color: rgb(243, 246, 255);
}
._navCard_kghbt_30 .ui-badge--top-right {
    transform: translate(100%,-50%);
    right: .21rem;
    top: -.02rem;
    max-width: 1.2rem
}
.ui-badge--fixed {
    position: absolute;
    transform-origin: 100%;
}
.ui-badge {
    display: inline-block;
    box-sizing: border-box;
    width: 35px;
    color: #fff;
    height: 14px;
    line-height: 14px;
    text-align: center;
    background: #f93b3b;
    border-radius: .19rem .23rem .23rem 0;
    font-size: .1rem;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    overflow: visible;
    vertical-align: middle;
    position: absolute;
    right: -23px;
    top: -35px
}
.ui-badge:before {
    content: "";
    display: inline-block;
    position: absolute;
    bottom: -.06rem;
    z-index: 20;
    left: 0;
    width: 0;
    height: 0;
    border-left: .079rem solid #f93b3b;
    border-top: .066rem solid transparent;
    border-bottom: .066rem solid transparent;
    font-size: 0;
}
.ui-badge__content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    position: relative;
    z-index: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue